import { useTranslation } from '../i18n';
import LanguageSwitcher from './LanguageSwitcher';
import "./LanguageTransition.css";

function JaninaAndCharles() {
  const { t, isTransitioning } = useTranslation();
  
  const styles = {
    container: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "30px 20px",
      textAlign: "left",
      backgroundColor: "var(--bg-default)",
    },
    heading: {
      fontFamily: "'Noto Serif Display', serif",
      fontSize: "clamp(2rem, 8vw, 4rem)",
      fontWeight: 300,
      letterSpacing: "0.1em",
      color: "var(--text-dark)",
      margin: 0,
      textTransform: "uppercase",
      lineHeight: 1.2,
      textAlign: "right",
      flex: 1,
    },
  };

  return (
    <section style={styles.container}>
      <LanguageSwitcher />
      <h1 style={styles.heading}>
        {t('janinaCharles.janina')}<br />
        {t('janinaCharles.charles')}
      </h1>
    </section>
  );
}

export default JaninaAndCharles;
